import { getAuthToken } from './auth';

const baseUrl = process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, '') ?? '';

type RequestOptions = RequestInit & {
  skipAuth?: boolean;
};

export async function apiFetch<T>(
  path: string,
  options: RequestOptions = {},
): Promise<T> {



  const { skipAuth, headers, ...rest } = options;
  const token = getAuthToken();

  const finalHeaders = new Headers(headers as HeadersInit | undefined);

  const isFormData = (options.body && typeof FormData !== 'undefined' && options.body instanceof FormData) as boolean;
  if (!finalHeaders.has('Content-Type') && !isFormData) {
    finalHeaders.set('Content-Type', 'application/json');
  }

  if (!skipAuth && token) {
    finalHeaders.set('Authorization', `Bearer ${token}`);
  }

  const response = await fetch(`${baseUrl}${path}`, {
    ...rest,
    headers: finalHeaders,
  });

  if (!response.ok) {
    let errorMessage = response.statusText;

    const rawBody = await response.text();

    if (rawBody) {
      try {
        const errorBody = JSON.parse(rawBody) as any;

        if (typeof errorBody === 'string') {
          errorMessage = errorBody;
        } else if (errorBody && typeof errorBody === 'object') {
          const topMessage = typeof errorBody.message === 'string' ? errorBody.message : undefined;
          const arrayMessages = Array.isArray(errorBody.message) ? errorBody.message.join(', ') : undefined;
          const nestedDataMessage = errorBody.data && typeof errorBody.data === 'object' && typeof errorBody.data.message === 'string'
            ? errorBody.data.message
            : undefined;
          const nestedError = errorBody.error;
          const nestedErrorMessage =
            typeof nestedError === 'string'
              ? nestedError
              : nestedError && typeof nestedError === 'object' && typeof nestedError.message === 'string'
                ? nestedError.message
                : undefined;

          errorMessage = topMessage || arrayMessages || nestedErrorMessage || nestedDataMessage || response.statusText;

          if (!errorMessage) {
            errorMessage = JSON.stringify(errorBody);
          }
        }
      } catch {
        errorMessage = rawBody;
      }
    }

    throw new Error(errorMessage || 'Request failed');
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return (await response.json()) as T;
}
